import React from 'react';
import classnames from 'classnames';
import { useDeviationViewContext } from '../../../Context';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import s from './StageContainer.scss';
export var StageContainer = function (_a) {
    var children = _a.children, className = _a.className;
    var _b = useDeviationViewContext(), isTheater = _b.isTheater, isFullscreen = _b.isFullscreen;
    return (React.createElement("div", { className: classnames(s['stage-content'], isTheater && s['theater'], isFullscreen && s['fullscreen'], className), "data-hook": BiDataHook.DEVIATION_ART_STAGE }, children));
};
StageContainer.displayName = 'StageContainer';
export default StageContainer;
//# sourceMappingURL=StageContainer.js.map